import React from 'react';
import classNames from 'classnames';

import styles from './LinkLikeText.scss';

export default function LinkLikeText({
  children,
  monochrome,
  ...restProps
}: {
  children: React.ReactNode;
  monochrome?: boolean;
}) {
  const className = classNames(
    styles.LinkLikeText,
    monochrome && styles.Monochrome
  );

  return (
    <span className={className} {...restProps}>
      {children}
    </span>
  );
}
